export default __webpack_public_path__ + "static/media/Metropolis-BlackItalic.c6d3c867.otf";